import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';

const Soporte = ({ onMenuSelect }) => {
  const [selectedMenu, setSelectedMenu] = useState('soporte');

  const handleMenuSelect = (menuId) => {
    setSelectedMenu(menuId);
    if (onMenuSelect) {
      onMenuSelect(menuId);
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar 
        onMenuSelect={handleMenuSelect}
        activeMenu={selectedMenu}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Soporte</h1>
            <p className="text-gray-600 mt-1">Obtén ayuda y reporta problemas</p>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-auto p-6 flex items-center justify-center">
          <div className="max-w-2xl w-full">
            <div className="bg-white rounded-lg shadow-sm p-8 text-center">
              {/* Support Icon */}
              <div className="mb-8">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
                  <svg className="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8.25v3.75m0 0v3.75m0-3.75h3.75m-3.75 0H8.25" />
                  </svg>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">¿Necesitas ayuda?</h2>
                <p className="text-gray-600">
                  Si tienes algún problema o error con el sistema, puedes contactarnos a través de los siguientes medios:
                </p>
              </div>

              {/* Contact Information */}
              <div className="space-y-6 max-w-lg mx-auto">
                {/* Email */}
                <div className="flex flex-col items-center space-y-3 p-4 bg-gray-50 rounded-lg">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="text-center">
                    <h3 className="font-medium text-gray-900 mb-1">Correo Electrónico</h3>
                    <p className="text-gray-600 text-sm mb-2">
                      Envíanos un correo con la descripción detallada del problema
                    </p>
                    <a 
                      href="mailto:mindntlabs@gmail.com" 
                      className="text-blue-600 hover:text-blue-800 font-medium transition-colors"
                    >
                      mindntlabs@gmail.com
                    </a>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex flex-col items-center space-y-3 p-4 bg-gray-50 rounded-lg">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div className="text-center">
                    <h3 className="font-medium text-gray-900 mb-1">Teléfono</h3>
                    <p className="text-gray-600 text-sm mb-2">
                      Llámanos para recibir asistencia inmediata
                    </p>
                    <a 
                      href="tel:+529991778325" 
                      className="text-green-600 hover:text-green-800 font-medium transition-colors"
                    >
                      +52 999 177 8325
                    </a>
                  </div>
                </div>
              </div>

              {/* Additional Info */}
              <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200 text-left max-w-lg mx-auto">
                <div className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <h4 className="font-medium text-blue-900 mb-1">Consejos para reportar problemas</h4>
                    <ul className="text-blue-800 text-sm space-y-1">
                      <li>• Describe el problema con el mayor detalle posible</li>
                      <li>• Incluye los pasos que seguiste antes del error</li>
                      <li>• Menciona en qué sección del sistema ocurrió</li>
                      <li>• Si es posible, adjunta capturas de pantalla</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Soporte;